var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itemBoxComparison"},[_c('div',{staticClass:"footer"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.record.img,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }